import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useBrandStore } from '../stores/brandStore'
import { RadcliffeHeader } from './layout/RadcliffeHeader'
import { appConfig } from '../config/app-config'
// import RollbarTest from "../components/RollbarTest";


export function Home() {
  const [searchParams] = useSearchParams()
  const message = searchParams.get('message')
  const loadBrand = useBrandStore((state) => state.loadBrand)
  const config = useBrandStore((state) => state.config)
  const loading = useBrandStore((state) => state.loading)

  // Load default brand on mount
  useEffect(() => {
    loadBrand(appConfig.defaultBrandId)
  }, [loadBrand])

  // Don't render until brand is loaded to prevent flash
  if (loading || !config) {
    return null
  }

  return (
    <>
      <RadcliffeHeader headerMode="banner" />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 'calc(100vh - 80px)',
          fontSize: '1.5rem',
          color: '#666',
          textAlign: 'center',
          padding: '2rem',
        }}
      >
        <div>{message || 'Survey not specified'}</div>
          {/* <RollbarTest /> */}
      </div>
    </>
  )
}
